var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.615 20.634H7C6.46957 20.634 5.96086 20.4233 5.58579 20.0482C5.21071 19.6732 5 19.1645 5 18.634V6.63403C5 6.1036 5.21071 5.59489 5.58579 5.21982C5.96086 4.84475 6.46957 4.63403 7 4.63403H15C15.5304 4.63403 16.0391 4.84475 16.4142 5.21982C16.7893 5.59489 17 6.1036 17 6.63403V14.634M14 19.634L16 21.634L20 17.634M9 8.63403H13M9 12.634H11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuLeads);
export default __webpack_public_path__ + "static/media/icon_menu_leads.40e65da4c61a69eeeb788595dd064f86.svg";
export { ForwardRef as ReactComponent };